import PremiumPageHeader from './PremiumPageHeader';
import ListViewSettings from './ListViewSettings';
import SettingsIcon from './SettingsIcon';
import { ListPageFloatingControls } from './ListPageLayout';

export const openContextualSettings = () => {
    window.dispatchEvent(new CustomEvent('openContextualSettings'));
};

export const LIST_FORM_SUBTITLE = 'Browse and manage records from this list view.';
export const LIST_FORM_SUBTITLE_WITH_SETTINGS =
    'Configure filters in General Settings. The table loads based on your saved preferences.';

function ListFormPageHeader({
    module,
    title,
    subtitle,
    viewKey,
    onSettingsSaved,
    headerActions,
    modeLabel = 'VIEW MODE',
    formLink,
    addNewLabel = 'Add New',
    homeLink = '/Home',
    headerBackground,
    showFloatingControls = true,
    showContextualSettings = false,
}) {
    const resolvedSubtitle = subtitle || (
        viewKey && onSettingsSaved ? LIST_FORM_SUBTITLE_WITH_SETTINGS : LIST_FORM_SUBTITLE
    );

    const contextualSettingsAction = showContextualSettings ? (
        <SettingsIcon onClickHandler={openContextualSettings} variant="inline" />
    ) : null;

    const resolvedActions = headerActions || (
        viewKey ? (
            <ListViewSettings viewKey={viewKey} onSaved={onSettingsSaved} />
        ) : showContextualSettings ? (
            contextualSettingsAction
        ) : null
    );

    return (
        <>
            {showFloatingControls ? (
                <ListPageFloatingControls
                    formLink={formLink}
                    addNewLabel={addNewLabel}
                    homeLink={homeLink}
                />
            ) : null}
            <div className="premium-page-header-wrap">
                <PremiumPageHeader
                    module={module}
                    title={title}
                    subtitle={resolvedSubtitle}
                    modeLabel={modeLabel}
                    headerActions={resolvedActions}
                    headerBackground={headerBackground}
                />
            </div>
        </>
    );
}

export default ListFormPageHeader;
